var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.892,
    viewBox: "0 0 16 16.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M6.852,16.465H3.392a2.046,2.046,0,0,1-2.038-2.031V7.553a1.271,1.271,0,0,1,.459-.97l.609-.451A.677.677,0,0,0,1.64,5.055h0l-.624.466A2.617,2.617,0,0,0,0,7.553v6.889a3.4,3.4,0,0,0,3.392,3.392h3.46a.677.677,0,1,0,0-1.354Z",
    transform: "translate(0 -0.941)",
    fill: "#200e32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M16.66,6.756a2.6,2.6,0,0,0-.965-2L10.608.678a3.042,3.042,0,0,0-3.829,0L5.166,1.855a.682.682,0,0,0-.155.948.673.673,0,0,0,.942.155L7.589,1.729a1.73,1.73,0,0,1,2.209,0l5.088,4.08a1.254,1.254,0,0,1,.471.963v6.782a1.994,1.994,0,0,1-1.988,2H11.859a.281.281,0,0,1-.28-.281V12.213a1.765,1.765,0,0,0-1.752-1.769H7.618a1.755,1.755,0,0,0-1.244.518,1.775,1.775,0,0,0-.515,1.251v1.17a.663.663,0,1,0,1.325,0v-1.17a.431.431,0,0,1,.122-.308.426.426,0,0,1,.3-.128H9.82a.428.428,0,0,1,.427.429h0v3.065a1.617,1.617,0,0,0,1.612,1.614h1.473a3.33,3.33,0,0,0,3.321-3.339Z",
    transform: "translate(-0.66)",
    fill: "#200e32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a101b737d595dd27bb150cbf3375c62b.svg";
export { ForwardRef as ReactComponent };